export const map = {
  accessToken:
    "pk.eyJ1Ijoic2hpZmF0IiwiYSI6ImNrNDhtMW02MTAxOHkzZm1tdHdra200Z3gifQ.UzkcKgTbOXemqyw-e-qVfA",
  style: "mapbox://styles/shifat/ck48m6mum0d9b1cmfw6ompyeo",
  coordinates: [90.4703, 23.7135],
};
